import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/categories/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/categories`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/categories/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/categories/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/categories`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/categories/${url.id}`, data, config),
};

export default requests;
